import {
  ItemDescription,
  ItemTitle,
  ItemVideoWrapper,
} from 'components/Product/Atoms/Feature';
import { useAutoPlayVideoWhenVisible } from 'hooks';
import React from 'react';
import styled from 'styled-components';

interface Props {
  videoSrc: string;
  featureTitle: string;
  featureDescription?: string;
}

export const ItemVideoComponent = ({
  videoSrc,
  featureTitle,
  featureDescription,
}: Props) => {
  const setRefs = useAutoPlayVideoWhenVisible();

  return (
    <ItemVideoComponentContainer>
      <ItemTitle>{featureTitle}</ItemTitle>

      <ItemVideoWrapper className="item-wrapper">
        <video src={videoSrc} loop muted playsInline controls ref={setRefs} />
      </ItemVideoWrapper>

      {featureDescription && (
        <ItemDescription className="item-desc">
          {featureDescription}
        </ItemDescription>
      )}
    </ItemVideoComponentContainer>
  );
};

export const ItemCommonComponentContainer = styled.article`
  & + & {
    margin-top: 96px;
  }

  @media screen and (max-width: 904px) {
    & + & {
      margin-top: 56px;
    }
  }
`;

const ItemVideoComponentContainer = styled(ItemCommonComponentContainer)`
  & video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  & .item-wrapper {
    margin-top: 8px;
  }
  & .item-desc {
    margin-top: 8px;
  }
`;
